/* eslint-disable react/prop-types */
import React, { useState, useContext } from "react";
import withRouter from "../WithRouter";
import { Link } from "react-router-dom";
import axios from "axios";
import { Col, Row, Button, Form, Container } from "react-bootstrap";
//Context
import { BusinessContextConsumer } from "../BusinessContext";
//Images and Icons
import { MdLogin } from "react-icons/md";
// Common
import StatusBlock from "../common/StatusBlock";
import FadeIn from "../common/FadeIn";
//Password Warnings
import {
  PasswordStrongSpan,
  PasswordWeakSpan,
  PasswordMediumSpan,
  PasswordMismatchSpan,
} from "../common/PasswordStrengthSpans";

const ReplacePassword = (props) => {
  // Password Strength Regex
  const passwordRegexStrong = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  const passwordRegexStrong2 = new RegExp(
    "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{20,})"
  );
  const passwordRegexMedium = new RegExp(
    "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"
  );
  // Handle Context
  const BusinessContext = useContext(BusinessContextConsumer);
  const businessID = BusinessContext.businessID;
  //State
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  // Handle Clicks, Submits, Errors
  const [submitClicked, setSubmitClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // Get the Password Reset Data
  const id = props.params.id;
  const token = props.params.token;
  //Boolean Checks on password strength
  const checkPasswordMedium = passwordRegexMedium.test(password);
  const checkPasswordStrong =
    passwordRegexStrong.test(password) || passwordRegexStrong2.test(password);
  const passwordTyped = password.length > 0;
  const passwordMatched = password === confirmPassword;

  // Handle the Submission
  const changePassword = async (e) => {
    e.preventDefault();
    //Set the Submit State
    setSubmitClicked(true);
    const data = {
      password,
      businessID,
    };
    // If Passwords Don't Match
    if (!passwordMatched) {
      setSubmitClicked(false);
      return setErrorMessage("Your passwords do not match.");
    }
    //If Passwords Match
    if (passwordMatched) {
      const passwordResetRequest = await axios.post(
        `/api/customer/customer_users/recover/${token}/${id}`,
        data,
        {
          withCredentials: true,
        }
      );

      if (passwordResetRequest.status === 200) {
        setSubmitClicked(false);
        return setSuccessMessage("Your password was reset. You may now login.");
      } else {
        setSubmitClicked(false);
        setErrorMessage("There was a problem with your request.");
      }
    }
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className='passwordResetFormCustomer'>
      <FadeIn delay={250} duration={450}>
        <Container>
          <Row>
            <Col sm='12'>
              <Form onSubmit={changePassword} className='shadow p-4 loginForm mx-auto'>
                <h3>Change Password</h3>
                <Row className='mt-3 mb-3'>
                  <Col sm='12'>
                    <Form.Group controlId='email'>
                      <Form.Label>Password:</Form.Label>
                      <Form.Control
                        type='password'
                        maxLength='256'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className='border'
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {!passwordMatched && <PasswordMismatchSpan />}
                    {passwordMatched &&
                      passwordTyped &&
                      !checkPasswordMedium &&
                      !checkPasswordStrong && <PasswordWeakSpan />}
                    {passwordMatched && checkPasswordMedium && !checkPasswordStrong && (
                      <PasswordMediumSpan />
                    )}
                    {passwordMatched && checkPasswordStrong && <PasswordStrongSpan />}
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col sm='12'>
                    <Form.Group controlId='password'>
                      <Form.Label>Confirm Password:</Form.Label>
                      <Form.Control
                        type='password'
                        maxLength='256'
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className='border'
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div>
                  <StatusBlock
                    errorMessage={errorMessage}
                    successMessage={successMessage}
                    dismissMessages={dismissMessages}
                  />
                </div>
                {submitClicked && errorMessage.length !== "" ? (
                  <Button variant='secondary' size='lg' type='submit' disabled className='mb-3'>
                    Processing
                  </Button>
                ) : (
                  <Button variant='primary' size='lg' type='submit' className='mb-3'>
                    Change Password <MdLogin />
                  </Button>
                )}
                <div>
                  <Link to='/admin/reset'>Try Again</Link>.
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </FadeIn>
    </div>
  );
};

//export the component
export default withRouter(ReplacePassword);
